import BuyAndSell from '@components/pump-buy-and-sell';
import PumpCompleted from '@components/pump-completed';
import PumpSwap from '@components/pump-swap';
import { useIsBlack } from '@hooks/use-is-black';
import { usePool } from '@hooks/use-pool';
import { usePumpPool } from '@hooks/use-pump-pool';
import { globalSettingModel } from '@models/global-setting.model';
import Dialog from '@ui/dialog';
import Loading from '@ui/loading';
import { useModel } from 'foca';
import { FC } from 'react';
import { useWindowSize } from 'react-use';
import styles from './index.module.scss';

const Trade: FC = () => {
  const buyData = useModel(globalSettingModel, (state) => state.buyData);
  const { width } = useWindowSize();
  const coinType = buyData.token_address;
  const pool = usePumpPool(coinType);
  const poolFields = usePool(coinType);
  const isBlack = useIsBlack(coinType);

  return (
    <Dialog
      rootClassName={styles.trade}
      visible={buyData.visible}
      maskClosable={width < 640 ? true : false}
      onClose={() =>
        globalSettingModel.setTradeVisible({
          visible: false,
          token_address: '',
          name: '',
          symbol: '',
          iconUrl: '',
        })
      }
      title={
        <div className={`${styles.ranking}`}>
          <img src={buyData.iconUrl} />
          <div className={styles.name_symbol}>
            <p>{buyData.name} </p>
            <p>${buyData.symbol}</p>
          </div>
        </div>
      }
      closable
      width={480}
    >
      {!pool || !poolFields ? (
        <div className={styles.loading}>
          <Loading size={64} />
        </div>
      ) : pool.is_completed ? (
        pool.clmm_pool_id ? (
          <PumpSwap pool={pool} className={styles.quickly_trade} />
        ) : (
          <PumpCompleted className={styles.quickly_swap} />
        )
      ) : (
        <BuyAndSell
          pool={pool}
          poolFields={poolFields}
          isBlack={isBlack}
          className={styles.quickly_swap}
        />
      )}
    </Dialog>
  );
};

export default Trade;
